import React from "react";
import { BioContainer, BioText, BioP } from "./SharedBioStyles";

function LongBio() {
    return (
        <BioContainer>
            <BioText>
                <BioP>
                    <strong>Mark Pascucci-Clifford</strong> is an Oakland-based vibraphonist, percussionist, pianist, composer, educator, and producer whose work spans classical, new music, jazz, free improvisation, and art rock.
                </BioP>
                <BioP>
                    He has performed on over 30 recordings and appeared with artists including Lisa Mezzacappa, Scott Amendola, Fred Frith, Jeff Parker, Ches Smith, Joan La Barbara, and Ron Miles, as well as with The Colorado Symphony Orchestra, So Percussion, sfSound, and the Oakland Active Orchestra. Recent highlights include a 2025 debut at The Stone in New York City with Lisa Mezzacappa’s 5ish and headlining the 2024 Outsound Summit with his ensemble, The Dirty Snacks Ensemble.
                </BioP>
                <BioP>
                    As a composer, Clifford has received commissions from Switchboard Presents, New Keys Ensemble, and the Samantha Stone Dance Collective, and was composer-in-residence at Lijiang Studio in Yunnan, China.
                </BioP>
                <BioP>
                    He is the founder and leader of <em>The Dirty Snacks Ensemble</em>, an eclectic post-jazz group whose second album, <em>You Would Do Well</em> (Slow &amp; Steady Records, 2022), was named “One of the Best of 2022” by Andy Gilbert of the <em>Classical Voice</em>.
                </BioP>
                <BioP>
                    Clifford also collaborates extensively with his partner and wife, Crystal Pascucci-Clifford, co-leading the ensembles Two Aerials and Inner Movements, which feature original compositions shaped by their shared improvisational language.
                </BioP>
                <BioP>
                    He holds a B.M. in Classical Percussion Performance from the Lamont School of Music and has studied with John Kinzie, Steve Nelson, Matt Moran, Tomomi Sugo, and John Hollenbeck.
                </BioP>
            </BioText>
        </BioContainer>
    );
}

export default LongBio;
